import Phaser from 'phaser';
import { GAME_WIDTH, getGameHeight } from '../config/constants';

/**
 * Draw the standard dark-blue gradient background used across all scenes.
 * Returns the Graphics object so it can be added to containers or have depth set.
 */
export function drawGradientBackground(scene: Phaser.Scene, depth?: number): Phaser.GameObjects.Graphics {
  const bg = scene.add.graphics();
  if (depth !== undefined) bg.setDepth(depth);
  const steps = 32;
  const stripH = Math.ceil(getGameHeight() / steps);
  for (let i = 0; i < steps; i++) {
    const t = i / (steps - 1);
    const r = Math.round(13 + t * 13);
    const g = Math.round(13 + t * 3);
    const b = Math.round(26 + t * 22);
    bg.fillStyle((r << 16) | (g << 8) | b, 1);
    bg.fillRect(0, i * stripH, GAME_WIDTH, stripH + 1);
  }
  return bg;
}
